/*
 * Bundle builder v6 — the product is ONE 10 lb combo bag.
 *
 * Options 1 & 2 are the two DIFFERENT colors OF that bag: a pair
 * resolves to the matching CUBED ICE-<C1>-<C2>-10lb Bag (both
 * orderings). Same-color picks are rejected here on purpose — solid
 * bags (e.g. the OG Blue) are sold on their own product page, not
 * through this mixed-color builder. Option 3 is the upsell: a
 * single-color 5 lb bag added alongside (15 lb total).
 *
 * Unavailable pairs get a notify link per-selection; full preview mode
 * engages only when no 10 lb products are active. Re-inits on
 * shopify:section:load.
 */
(function () {
  'use strict';

  function initBundle(root) {
    if (root.dataset.bundleInit) return;
    root.dataset.bundleInit = '1';

    var mapEl = root.querySelector('[data-bundle-products]');
    var data;
    try {
      data = JSON.parse(mapEl.textContent);
    } catch (e) {
      return;
    }
    var combos = data.combos || {};
    var singles = data.singles || {};
    var addons = data.addons || {};

    var preview = root.hasAttribute('data-bundle-preview');
    var halves = {
      1: root.querySelector('[data-bundle-half="1"]'),
      2: root.querySelector('[data-bundle-half="2"]')
    };
    var slots = {
      1: root.querySelector('[data-bundle-slot="1"]'),
      2: root.querySelector('[data-bundle-slot="2"]'),
      3: root.querySelector('[data-bundle-slot="3"]')
    };
    var hint = root.querySelector('[data-bundle-hint]');
    var note = root.querySelector('[data-bundle-note]');
    var status = root.querySelector('[data-bundle-status]');
    var cta = root.querySelector('[data-bundle-cta]');
    var notifyLink = root.querySelector('[data-bundle-notify]');
    // The section's own waitlist target, kept so it can be restored for pairs
    // that have no product to point at.
    var waitlistHref = notifyLink ? notifyLink.getAttribute('href') : '';
    var viewLink = root.querySelector('[data-bundle-view]');
    var summary = root.querySelector('[data-bundle-summary]');
    var summaryRows = root.querySelector('[data-summary-rows]');
    var summaryTotal = root.querySelector('[data-summary-total]');
    var upsell = root.querySelector('[data-bundle-upsell]');
    var mainSwatches = Array.prototype.slice.call(root.querySelectorAll('[data-bundle-color]'));
    var upsellSwatches = Array.prototype.slice.call(root.querySelectorAll('[data-upsell-color]'));

    var labelCombo = cta.dataset.labelCombo || cta.textContent;
    var labelBundle = cta.dataset.labelBundle || labelCombo;

    var picks = { 1: null, 2: null, 3: null };
    var upsellPossible = preview || Object.keys(addons).length > 0;

    function cap(s) {
      return s.charAt(0).toUpperCase() + s.slice(1);
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function comboName() {
      return cap(picks[1].color) + ' & ' + cap(picks[2].color);
    }

    function resolveCombo() {
      if (!(picks[1] && picks[2])) return null;
      var a = picks[1].color, b = picks[2].color;
      return combos[a + '-' + b] || combos[b + '-' + a] || null;
    }

    function render() {
      [1, 2, 3].forEach(function (n) {
        var pick = picks[n];
        if (halves[n]) {
          if (pick) {
            halves[n].style.background = pick.hex;
            halves[n].classList.add('is-in');
          } else {
            halves[n].classList.remove('is-in');
          }
        }
        if (pick) {
          slots[n].hidden = false;
          root.querySelector('[data-slot-dot="' + n + '"]').style.background = pick.hex;
          root.querySelector('[data-slot-label="' + n + '"]').textContent =
            n < 3 ? 'Option ' + n + ' · ' + cap(pick.color) : '5 lb Bag · ' + cap(pick.color);
        } else {
          slots[n].hidden = true;
        }
      });

      hint.classList.toggle('is-hidden', !!(picks[1] || picks[2]));
      note.hidden = true;

      mainSwatches.forEach(function (s) {
        var c = s.dataset.bundleColor;
        s.classList.toggle(
          'is-picked',
          (picks[1] && picks[1].color === c) || (picks[2] && picks[2].color === c)
        );
      });
      upsellSwatches.forEach(function (s) {
        var c = s.dataset.upsellColor;
        s.classList.toggle('is-picked', !!(picks[3] && picks[3].color === c));
        s.disabled = !(preview || (addons[c] && addons[c].available));
        // Same distinction as the combo message: a colour we stock but have
        // run out of is sold out, not unreleased.
        if (s.disabled) s.title = cap(c) + (addons[c] ? ' (sold out)' : ' (coming soon)');
      });

      var bothPicked = !!(picks[1] && picks[2]);
      var combo = resolveCombo();
      var comboOk = !!(combo && combo.available);
      var addonOk = !picks[3] || (picks[3] && addons[picks[3].color] && addons[picks[3].color].available);

      upsell.hidden = !(bothPicked && upsellPossible);

      summary.hidden = !bothPicked;
      if (bothPicked) {
        var rows = '';
        var total = 0;
        var priced = true;
        var comboPrice = '';
        if (comboOk) {
          comboPrice = '<span>' + combo.price + '</span>';
          total += combo.cents;
        } else {
          priced = false;
        }
        rows += '<li><span>1 × ' + comboName() + ' 10 lb Combo Bag</span>' + comboPrice + '</li>';
        if (picks[3]) {
          var a = addons[picks[3].color];
          if (a && a.available) {
            rows += '<li><span>1 × ' + cap(picks[3].color) + ' 5 lb Bag</span><span>' + a.price + '</span></li>';
            total += a.cents;
          } else {
            rows += '<li><span>1 × ' + cap(picks[3].color) + ' 5 lb Bag</span></li>';
            priced = false;
          }
        }
        summaryRows.innerHTML = rows;
        summaryTotal.textContent =
          (picks[3] ? '15' : '10') + ' lb Total' + (priced && total ? ' · ' + money(total) : '');
      }

      cta.textContent = picks[3] ? labelBundle : labelCombo;

      if (!bothPicked) {
        cta.hidden = false;
        cta.disabled = true;
        notifyLink.hidden = true;
        if (viewLink) viewLink.hidden = true;
        status.textContent = picks[1] ? 'Pick a second color.' : '';
      } else if (comboOk && addonOk) {
        cta.hidden = false;
        cta.disabled = false;
        notifyLink.hidden = true;
        if (viewLink) viewLink.hidden = true;
        status.textContent = comboName() + ' combo bag is in stock.';
      } else {
        // This pair isn't purchasable yet.
        cta.hidden = true;
        cta.disabled = true;
        notifyLink.hidden = false;
        /*
         * Where "notify me" goes decides whether the signup is worth
         * anything. The product page's form tags the customer with that
         * product's handle, so a restock email can go only to the people who
         * wanted THIS colour. The section's generic waitlist records that
         * somebody wanted something and nothing more — so it is the fallback,
         * used only for pairs that have no product to point at.
         */
        if (combo && combo.url) {
          notifyLink.href = combo.url;
          // The shared dialog reads these; the href stays as the no-JS path.
          notifyLink.setAttribute('data-notify-open', '');
          notifyLink.setAttribute('data-notify-handle', combo.url.split('/products/').pop());
          notifyLink.setAttribute('data-notify-label', comboName());
          // It would land on the same page as notify, so one CTA, not two.
          if (viewLink) viewLink.hidden = true;
        } else {
          notifyLink.href = waitlistHref;
          // No product means no handle to tag, so let the link do its job
          // rather than opening a dialog that cannot scope the signup.
          notifyLink.removeAttribute('data-notify-open');
          notifyLink.removeAttribute('data-notify-handle');
          notifyLink.removeAttribute('data-notify-label');
          if (viewLink) viewLink.hidden = true;
        }
        /*
         * Two different states were wearing one message. A pair with a
         * product behind it is SOLD OUT — it existed, it will be restocked.
         * A pair with no product has never been made. Telling a shopper the
         * Purple & Yellow bag is "coming soon" implies a launch that isn't
         * happening and hides the fact that it's simply out of stock.
         * `combo` is non-null exactly when the product exists, which is the
         * same test the View-product-page button already uses below.
         */
        if (combo) {
          status.textContent = 'The ' + comboName() +
            ' combo bag is sold out. Join the list and we\'ll email you when it\'s back.';
        } else {
          status.textContent = 'The ' + comboName() + ' combo bag is coming soon. Join the list and be first.';
        }
      }
    }

    function updateHeaderCartCount() {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var link = document.querySelector('.site-header__cart');
          if (!link) return;
          var badge = link.querySelector('.site-header__cart-count');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__cart-count';
            badge.setAttribute('aria-hidden', 'true');
            link.appendChild(badge);
          }
          badge.textContent = cart.item_count;
        })
        .catch(function () {});
    }

    function addBundle() {
      var combo = resolveCombo();
      if (!combo || !combo.available) return;
      var items = [{ id: combo.variant, quantity: 1 }];
      var lbs = 10;
      if (picks[3] && addons[picks[3].color] && addons[picks[3].color].available) {
        items.push({ id: addons[picks[3].color].variant, quantity: 1 });
        lbs = 15;
      }
      cta.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (r.ok) return null;
          // Shopify explains itself on a rejection ("...is already sold out"),
          // and that sentence is far more use to a shopper than anything this
          // file could invent. Keep it.
          return r.json().catch(function () { return null; }).then(function (body) {
            var err = new Error((body && body.description) ||
              "Couldn't add that just now. Try again.");
            err.soldOut = r.status === 422;
            throw err;
          });
        })
        .then(function () {
          picks[1] = picks[2] = picks[3] = null;
          render();
          status.textContent = lbs + ' lb added to cart. Build another?';
          updateHeaderCartCount();
          document.dispatchEvent(new CustomEvent('cart:open'));
        })
        .catch(function (err) {
          /*
           * The cart is the only authority on whether something can be bought.
           * A combo can read sellable in Liquid and still be refused here — the
           * variant is oversellable but unstocked at the location that fulfils
           * online orders — so when the cart says no, believe it over the
           * page's snapshot: drop the pair to unavailable and let render()
           * retire the button in favour of the notify link.
           */
          if (err && err.soldOut && combo) combo.available = false;
          // render() BEFORE the message, never after: it rewrites the status
          // line itself, so setting the text first was writing it into a value
          // that render() then overwrote. That is why a refused add looked like
          // a dead button — the failure was reported and erased in one frame.
          render();
          status.textContent = (err && err.message) ||
            "Couldn't add that just now. Try again.";
        });
    }

    mainSwatches.forEach(function (s) {
      s.addEventListener('click', function () {
        var color = s.dataset.bundleColor;
        var pick = { color: color, hex: s.dataset.hex };
        // Mixed-color only: a color already chosen in EITHER slot toggles
        // off, so the same color can never land in both slots. This also
        // covers the case where slot 1 was cleared while slot 2 holds a
        // color — clicking that color removes it rather than duplicating.
        if (picks[1] && picks[1].color === color) {
          picks[1] = null;
          render();
          return;
        }
        if (picks[2] && picks[2].color === color) {
          picks[2] = null;
          render();
          return;
        }
        if (!picks[1]) picks[1] = pick;
        else if (!picks[2]) picks[2] = pick;
        else {
          // Both slots full with two other colors — prompt to clear one.
          note.hidden = false;
          render();
          return;
        }
        render();
      });
    });

    upsellSwatches.forEach(function (s) {
      s.addEventListener('click', function () {
        if (s.disabled) return;
        var color = s.dataset.upsellColor;
        picks[3] = picks[3] && picks[3].color === color ? null : { color: color, hex: s.dataset.hex };
        render();
      });
    });

    [1, 2, 3].forEach(function (n) {
      slots[n].addEventListener('click', function () {
        picks[n] = null;
        render();
      });
    });

    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      addBundle();
    });

    render();
  }

  document.querySelectorAll('[data-bundle]').forEach(initBundle);

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-bundle]');
    if (root) initBundle(root);
  });
})();
